function observeElement(selector) {
  // Options for the observer (which part of the screen to observe)
  const options = {
    root: null, // observing relative to the viewport
    rootMargin: '0px',
    threshold: 0.1 // 10% of the element should be visible
  };

  // Callback function for the observer
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      // Checking if the element is intersecting (visible)
      if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
        $('.button-fixed').hide();
        // Optional: Unobserve after logging
        //observer.unobserve(entry.target);
      } else {
        $('.button-fixed').show();
      }
    });
  };

  // Creating an observer with the specified options and callback
  const observer = new IntersectionObserver(callback, options);

  // Getting the element(s) based on the selector
  const elements = document.querySelectorAll(selector);

  // Observing each element found
  elements.forEach(element => {
    observer.observe(element);
  });
}

// Example usage
observeElement('.product-form__buttons'); // Replace 'yourClassName' with your specific class name

// MEGA MENU VAN DYLAN
document.addEventListener('DOMContentLoaded', function () {
  const hasChildsItems = document.querySelectorAll('.has-childs');
  const desktopSub = document.querySelector('.desktop_submenu');
  const upperLvl = document.querySelectorAll('.upper-level');
  const blurOverlay = document.querySelector('.blur-overlay');
  const menuLinks = document.querySelectorAll('.hovered-state');
  const dynamicImage = document.querySelectorAll('.dynamic-collection-image');

  menuLinks.forEach(link => {
    link.addEventListener('mouseenter', function () {
      const collectionImage = link.getAttribute('data-collection-image');
      const collectionImageAlt = link.getAttribute('data-collection-image-alt');
      if (collectionImage) {
        dynamicImage.forEach(item => {
          item.src = collectionImage;
          item.alt = collectionImageAlt;
        });
      }
    });
    // link.addEventListener('mouseleave', function () {
    //   // Optionally, you can reset the image or leave it as is
    //   dynamicImage.forEach(item => {
    //     // item.src = item.getAttribute('data-collection-fallback-image');;
    //     item.alt = '';
    //   });
    // });
  });

  hasChildsItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      blurOverlay.style.display = 'block';
      document.body.classList.add("overflow-hidden");
    });
  });

  desktopSub.addEventListener('mouseleave', function () {
    blurOverlay.style.display = 'none';
    document.body.classList.remove("overflow-hidden");
  });

  upperLvl.forEach(function (item) {
    item.addEventListener('mouseleave', function () {
      blurOverlay.style.display = 'none';
      document.body.classList.remove("overflow-hidden");
    });
  });
});


const detailClick = document.querySelectorAll('.pdp-tab');
detailClick.forEach(function (detailDescription) {
  let closeBtnAdded = false; // Flag to check if close button event listener is added
  const detailTitle = detailDescription.querySelector('p'); // Target the <p> element

  detailTitle.addEventListener('click', function () {

    const detailContent = detailDescription.querySelector('.pdp-tab_content');
    const closeBtn = detailDescription.querySelector('#close-pdp_tab');

    // Close other open tabs
    detailClick.forEach(function (otherDetailDescription) {
      if (otherDetailDescription !== detailDescription) {
        const otherDetailContent = otherDetailDescription.querySelector('.pdp-tab_content');
        otherDetailContent.classList.remove('pdp-tab_open');
      }
    });

    detailContent.classList.add('pdp-tab_open');

    if (!closeBtnAdded) { // Only add the event listener if it hasn't been added
      closeBtn.addEventListener('click', function (event) {
        event.stopPropagation(); // Prevent the click event from bubbling up
        detailContent.classList.remove('pdp-tab_open');


      });
      closeBtnAdded = true; // Mark the close button event listener as added
    }
  });
});

/** Remove auto selecting on PDP **/
document.addEventListener('DOMContentLoaded', function () {
  // Find all fieldsets with the class 'product-form__input'
  const fieldsets = document.querySelectorAll('.field-nr-2');
  const submitButtons = document.querySelectorAll('.product-form__submit');
  const scrollOffset = 100; // Adjust this value as needed for the offset

  function updateSubmitButtonText() {
    let isAnyRadioSelected = false;

    //If there are no sizing options (for bags examples)
    if (fieldsets.length == 0) {
      isAnyRadioSelected = true;
    }
    fieldsets.forEach((fieldset) => {
      const radios = fieldset.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        if (radio.checked) {
          isAnyRadioSelected = true;
        }
      });
    });

    submitButtons.forEach((submitButton) => {
      const buttonTextElement = submitButton.querySelector('span');
      let spinnerElement = submitButton.querySelector('.loading-overlay__spinner');
      if (isAnyRadioSelected) {
        if (buttonTextElement) {
          buttonTextElement.textContent = 'Add to cart';
        }
        // Ensure the spinner element is present
        if (!spinnerElement) {
          spinnerElement = document.createElement('div');
          spinnerElement.className = 'loading-overlay__spinner';
          spinnerElement.innerHTML = `
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          `;
          submitButton.appendChild(spinnerElement);
        }
        // Remove aria-disabled attribute if it exists
        submitButton.setAttribute('aria-disabled', 'false');
      } else {
        if (buttonTextElement) {
          buttonTextElement.textContent = 'Select size';
        }
        // Remove the spinner element if it exists
        if (spinnerElement) {
          spinnerElement.remove();
        }
        // Add aria-disabled attribute
        submitButton.setAttribute('aria-disabled', 'false');
      }
    });
  }

  function handleFormSubmission(event) {
    let isAnyRadioSelected = false;

    fieldsets.forEach((fieldset) => {
      const radios = fieldset.querySelectorAll('input[type="radio"]');

      radios.forEach((radio) => {
        if (radio.checked) {
          isAnyRadioSelected = true;
        }
      });
    });

    if (!isAnyRadioSelected) {
      event.preventDefault();
      // alert('Please select a size.');
      // Scroll to the first fieldset with the class 'product-form__input' with an offset
      const fieldset = document.querySelector('.title-price-wrapper');
      if (fieldset) {
        const yOffset = -scrollOffset;
        const y = fieldset.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }

  // Initial check on page load
  updateSubmitButtonText();

  // Add event listeners to all radio buttons to update the submit button text when a size is selected
  fieldsets.forEach((fieldset) => {
    const radios = fieldset.querySelectorAll('input[type="radio"]');

    radios.forEach((radio) => {
      radio.addEventListener('change', updateSubmitButtonText);
    });
  });

  // Add event listeners to the forms containing the submit buttons to handle form submission
  submitButtons.forEach((submitButton) => {
    const form = submitButton.closest('form');
    if (form) {
      form.addEventListener('submit', handleFormSubmission);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('h2.footer-block__heading');

  function setInitialStates() {
    const isWideScreen = window.innerWidth >= 768;

    headings.forEach(heading => {
      const nextSibling = heading.nextElementSibling;
      const plusIcon = heading.querySelector('.plus-ico');

      // Set the initial state based on the screen width
      if (isWideScreen) {
        nextSibling.classList.add('open');
      } else {
        nextSibling.classList.remove('open');
      }

      if (nextSibling) {
        if (nextSibling.classList.contains('open')) {
          nextSibling.style.display = 'block';
        } else {
          nextSibling.style.display = 'none';
        }
      }

      if (plusIcon) {
        if (nextSibling.classList.contains('open')) {
          plusIcon.classList.add('rotate');
        } else {
          plusIcon.classList.remove('rotate');
        }
      }
    });
  }

  setInitialStates();

  headings.forEach(heading => {
    heading.addEventListener('click', () => {
      const nextSibling = heading.nextElementSibling;
      const plusIcon = heading.querySelector('.plus-ico');

      if (nextSibling) {
        if (nextSibling.style.display === 'none' || nextSibling.style.display === '') {
          nextSibling.style.display = 'block';
        } else {
          nextSibling.style.display = 'none';
        }
      }

      if (plusIcon) {
        plusIcon.classList.toggle('rotate');
      }

      // Toggle the open class on click
      heading.classList.toggle('open');
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("sticky-header");
  const headerInside = document.querySelector(".header--mobile-center");
  const placeholder = document.querySelector(".header-placeholder");
  const headerIconMenu = document.querySelector(".header__icon--menu");

  headerIconMenu.addEventListener("click", function () {
    headerInside.classList.toggle("background-nav");
  });

  const scrollOffset = 82; // gewenste scrollhoogte

  // Zet de hoogte van de placeholder gelijk aan de header
  placeholder.style.height = `${header.offsetHeight}px`;

  // Observer callback die continu updates geeft
  const observerCallback = function (entries) {
    entries.forEach(entry => {
      if (entry.boundingClientRect.top <= 82) {
        headerInside.classList.add("background-nav");
      } else {
        headerInside.classList.remove("background-nav");
      }
    });
  };

  // Gebruik een array met thresholds om continu te updaten (0.0 t/m 1.0)
  const observerOptions = {
    root: null, // de viewport
    threshold: Array.from({ length: 101 }, (_, i) => i / 100)
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  const target = document.querySelector(".product__info-wrapper.grid__item");
  if (target) {
    observer.observe(target);
  }

  // Scroll event voor de header-fixed en placeholder logica
  window.addEventListener("scroll", function () {
    if (window.scrollY > scrollOffset) {
      header.classList.add("fixed");
      placeholder.style.display = "block";

    } else {
      header.classList.remove("fixed");
      placeholder.style.display = "none";
    }
  });
});


